const DAY_MS = 86_400_000;

const startOfDay = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();

const timeOf = (d: Date) => d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });

/** "Today 15:00", "Tomorrow 16:00", "Yesterday 09:30", else "Fri 5 Sep 14:00". */
export function formatDue(iso: string, now = new Date()): string {
  const date = new Date(iso);
  const time = timeOf(date);
  const dayDiff = Math.round((startOfDay(date) - startOfDay(now)) / DAY_MS);
  if (dayDiff === 0) return `Today ${time}`;
  if (dayDiff === 1) return `Tomorrow ${time}`;
  if (dayDiff === -1) return `Yesterday ${time}`;
  const day = date.toLocaleDateString("en-GB", {
    weekday: "short",
    day: "numeric",
    month: "short",
    ...(date.getFullYear() !== now.getFullYear() ? { year: "numeric" } : {}),
  });
  return `${day} ${time}`;
}

/** "Fri 4 Sept 16:00" — absolute, short, for SMS text. */
export function formatDueSms(inputValue: string): string {
  const date = new Date(inputValue);
  if (Number.isNaN(date.getTime())) return "";
  const day = date.toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short" }).replace(/,/g, "");
  return `${day} ${timeOf(date)}`;
}

/** "Saturday, 5 Sept 2026 · 08:00" for a datetime-local input value; "" if unparsable. */
export function formatDueLong(inputValue: string): string {
  const date = new Date(inputValue);
  if (Number.isNaN(date.getTime())) return "";
  const day = date.toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "short", year: "numeric" });
  return `${day} · ${timeOf(date)}`;
}

export const isOverdue = (iso: string, now = new Date()) => new Date(iso).getTime() < now.getTime();

const pad = (n: number) => String(n).padStart(2, "0");

/** Local-time value for an <input type="datetime-local">. */
export function toInputValue(date: Date): string {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

/** Sensible default for a new task: the next full hour. */
export function defaultDue(now = new Date()): Date {
  const next = new Date(now);
  next.setMinutes(0, 0, 0);
  next.setHours(next.getHours() + 1);
  return next;
}
